import { Link } from "react-router-dom";
import styled from "styled-components";

export const Hero = styled.div`
  max-width: 1480px;
  margin: auto;

  margin-top: 6rem;
  display: grid;
  grid-template-columns: 45% 37%;
  justify-content: space-between;
  // border: 3px solid red;

  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    // justify-content: space-between;
  }
  @media screen and (max-width: 579px) {
  }
`;
export const HeroTitle = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  //   margin-left: 5rem;

  div {
    margin-left: 5rem;

    @media screen and (max-width: 991px) {
      margin-left: 5rem;
      margin-right: 5rem;
      display: flex;
      justify-content: center;
    }
    @media screen and (max-width: 579px) {
      margin-left: 2rem;
      margin-right: 2rem;
    }
  }

  @media screen and (max-width: 991px) {
    // padding-right: 0rem;
  }

  @media screen and (max-width: 579px) {
    // justify-content: flex-start;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  span {
    margin-left: 5rem;
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.secondary};

    @media screen and (max-width: 991px) {
      font-weight: 400;
      margin-top: 3rem;
      text-align: center;
      margin-left: 5rem;
      margin-right: 5rem;
    }
    @media screen and (max-width: 579px) {
      margin-left: 2rem;
      margin-right: 2rem;
    }
  }

  h1 {
    margin-top: 1rem;
    font-size: 56px;
    color: ${({ theme }) => theme.colors.body};
    // border: 10px solid brown;
    padding-left: 5rem;
    font-family: "Futura";
    line-height: 64px;
    font-weight: 400;
    @media screen and (max-width: 991px) {
      padding-left: 0rem;
      text-align: center;
      margin-right: 5rem;
      margin-left: 5rem;
    }
    @media screen and (max-width: 579px) {
      font-size: 2.5rem;
      font-weight: 900;
      // margin-left: 1rem;
      // margin-right: 1rem;
      line-height: 48px;
      width: 80%;
      margin: 1rem auto;
    }
  }
  p {
    margin-left: 5rem;
    padding-right: 2rem;
    margin-right: 5rem;
    margin-top: -1rem;
    font-size: 1.3rem;
    font-weight: 400;
    width: 75%;
    line-height: 32px;
    margin-bottom: 2.5rem;
    @media screen and (max-width: 991px) {
      text-align: center;
      width: 70%;
      margin: auto auto 4rem auto;
    }
    @media screen and (max-width: 579px) {
      font-size: 1.2rem;
      text-align: center;
      width: 90%;
      margin: auto auto 4rem auto;
      //   margin: 0 auto 3rem auto;
      padding-left: 1.5rem;
      //   padding-right: 1rem;
    }
  }
`;
export const Button = styled(Link)`
  background-color: ${(props) =>
    props.outline ? props.theme.colors.text : props.theme.colors.secondary};
  border-radius: 16px;
  color: ${(props) =>
    props.outline ? props.theme.colors.secondary : props.theme.colors.text};
  padding: 16px 80px 16px 80px;
  border: 1px solid
    ${(props) =>
      props.outline ? props.theme.colors.secondary : ''};
  &:hover {
    background-color: #00008b;
  }
  @media screen and (max-width: 579px) {
    font-size: 1rem;
  }
`;

export const HeroPicture = styled.div`
  margin-top: 1rem;
  padding-right: 5rem;

  img {
    width: 100%;
  }
  @media screen and (max-width: 991px) {
    padding-right: 0rem;
    img {
      width: 100%;
    }

    grid-row-start: 1;
    grid-row-end: 3;
  }
  @media screen and (max-width: 579px) {
    padding-right: 0rem;
    width: 100%;

    img {
      width: 100%;
    }
  }
`;
